/** @format */

import { useMemo } from "react";
import { useLocation, useNavigate, useParams, Location } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { QuestionModal } from "../../components/QuestionModal";
import { useCart } from "../../contexts/cart/useCart";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

export const PublicQuestionsPage = () => {
	const { id, locale } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const { t } = useTranslation();
	const { addParts, entryFor } = useCart();
	const initialSelectedPartIds = useMemo(
		() => (id ? (entryFor(id)?.selectedParts?.map((part) => part.id) ?? []) : []),
		[entryFor, id],
	);

	useDocumentTitle(id ? `${t("pageTitles.question")} ${id}` : t("pageTitles.question"));

	if (!id) {
		return null;
	}

	const isOpenedAsModal = Boolean((location.state as { backgroundLocation?: Location } | null)?.backgroundLocation);

	const handleClose = () => {
		// When opened over another page, step back so the underlying page (and its
		// scroll/filter state) is restored. Otherwise fall back to the search page.
		if (isOpenedAsModal) {
			navigate(-1);
		} else {
			navigate(`/${locale ?? "en"}/search`);
		}
	};

	return (
		<>
			<button aria-label="close question" className="fixed inset-0 bg-black/15 z-30" onClick={handleClose} />
			<QuestionModal
				questionId={id}
				onClose={handleClose}
				onAddParts={addParts}
				initialSelectedPartIds={initialSelectedPartIds}
			/>
		</>
	);
};
